import { render, staticRenderFns } from "./OurStory.vue?vue&type=template&id=3c7db4b8&"
import script from "./OurStory.vue?vue&type=script&lang=ts&"
export * from "./OurStory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimeline } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VTimeline})
